module.exports = __webpack_public_path__ + "static/media/大鳄周边@2x.980c04ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/大鳄周边@2x.png
// module id = 1530
// module chunks = 0